// `icon-dashboard`
export const IconDashBoard = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.72694 5.18636C3.72694 4.38 4.38062 3.72632 5.18698 3.72632H9.37848C10.1848 3.72632 10.8385 4.38 10.8385 5.18636V7.60878C10.8385 8.41514 10.1848 9.06882 9.37848 9.06882H5.18698C4.38062 9.06882 3.72694 8.41514 3.72694 7.60878V5.18636Z"
        fill={color}
      />
      <path
        d="M3.72656 12.8291C3.72656 12.0228 4.38025 11.3691 5.1866 11.3691H9.37811C10.1845 11.3691 10.8382 12.0228 10.8382 12.8291V18.8132C10.8382 19.6196 10.1845 20.2733 9.37811 20.2733H5.18661C4.38025 20.2733 3.72656 19.6196 3.72656 18.8132V12.8291Z"
        fill={color}
      />
      <path
        d="M13.162 18.8135C13.162 19.6199 13.8156 20.2736 14.622 20.2736H18.8135C19.6199 20.2736 20.2736 19.6199 20.2736 18.8135V16.3911C20.2736 15.5848 19.6199 14.9311 18.8135 14.9311H14.622C13.8156 14.9311 13.162 15.5848 13.162 16.3911V18.8135Z"
        fill={color}
      />
      <path
        d="M13.162 11.1708C13.162 11.9771 13.8156 12.6308 14.622 12.6308H18.8135C19.6199 12.6308 20.2736 11.9771 20.2736 11.1708V5.18667C20.2736 4.38032 19.6199 3.72663 18.8135 3.72663H14.622C13.8156 3.72663 13.162 4.38031 13.162 5.18667V11.1708Z"
        fill={color}
      />
    </svg>
  );
};

// `icon-card
export const IconCard = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 8.9069V7.3198C21.5 7.06004 21.4489 6.80282 21.3495 6.56283C21.2501 6.32285 21.1044 6.10479 20.9207 5.92111C20.737 5.73743 20.519 5.59174 20.279 5.49234C20.039 5.39294 19.7818 5.34178 19.522 5.3418H4.478C3.9534 5.3418 3.45029 5.55019 3.07934 5.92114C2.7084 6.29209 2.5 6.7952 2.5 7.3198V8.9069H21.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 10.3938V16.6804C2.5 17.205 2.7084 17.7081 3.07934 18.0791C3.45029 18.45 3.9534 18.6584 4.478 18.6584H19.522C19.7818 18.6584 20.039 18.6073 20.279 18.5079C20.519 18.4085 20.737 18.2628 20.9207 18.0791C21.1044 17.8954 21.2501 17.6773 21.3495 17.4374C21.4489 17.1974 21.5 16.9402 21.5 16.6804V10.3938H2.5ZM8.10501 15.5401C8.10501 15.4558 8.12162 15.3723 8.15388 15.2944C8.18615 15.2165 8.23344 15.1458 8.29305 15.0862C8.35267 15.0266 8.42345 14.9793 8.50134 14.947C8.57923 14.9148 8.66271 14.8982 8.74701 14.8982H12.6749C12.8438 14.9003 13.005 14.9689 13.1237 15.089C13.2424 15.2092 13.3089 15.3713 13.3089 15.5401C13.3089 15.709 13.2424 15.8711 13.1237 15.9913C13.005 16.1114 12.8438 16.18 12.6749 16.1821H8.74701C8.6627 16.1821 8.57921 16.1655 8.50131 16.1333C8.42342 16.101 8.35264 16.0537 8.29302 15.9941C8.2334 15.9345 8.18611 15.8637 8.15385 15.7858C8.12159 15.7079 8.105 15.6244 8.10501 15.5401ZM5.10897 14.9447C5.18779 14.9129 5.27213 14.8971 5.3571 14.8982H6.6424C6.72738 14.8971 6.81172 14.9129 6.89054 14.9447C6.96935 14.9765 7.04107 15.0236 7.10154 15.0833C7.162 15.1431 7.21001 15.2142 7.24278 15.2926C7.27554 15.371 7.29242 15.4551 7.29242 15.5401C7.29242 15.6251 7.27554 15.7093 7.24278 15.7877C7.21001 15.8661 7.162 15.9372 7.10154 15.9969C7.04107 16.0566 6.96935 16.1038 6.89054 16.1355C6.81172 16.1673 6.72738 16.1831 6.6424 16.1821H5.3571C5.27213 16.1831 5.18779 16.1673 5.10897 16.1355C5.03016 16.1038 4.95844 16.0566 4.89797 15.9969C4.83751 15.9372 4.7895 15.8661 4.75673 15.7877C4.72396 15.7093 4.70709 15.6251 4.70709 15.5401C4.70709 15.4551 4.72396 15.371 4.75673 15.2926C4.7895 15.2142 4.83751 15.1431 4.89797 15.0833C4.95844 15.0236 5.03016 14.9765 5.10897 14.9447Z"
        fill={color}
      />
    </svg>
  );
};

// icon wallet
export const IconWallet = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84212 4.71932C3.22559 5.33586 3.22559 6.32815 3.22559 8.31275V15.687C3.22559 17.6716 3.22559 18.6639 3.84212 19.2804C4.45866 19.897 5.45096 19.897 7.43556 19.897H17.2649C18.5779 19.897 19.2344 19.897 19.7232 19.6144C20.0424 19.4298 20.3075 19.1647 20.4921 18.8455C20.7747 18.3567 20.7747 17.7002 20.7747 16.3872H15.51C14.0561 16.3872 12.8776 15.2086 12.8776 13.7548C12.8776 12.301 14.0561 11.1224 15.51 11.1224H20.7747V8.31276C20.7747 6.32816 20.7747 5.33586 20.1581 4.71932C19.5416 4.10278 18.5493 4.10278 16.5647 4.10278H7.43556C5.45096 4.10278 4.45866 4.10278 3.84212 4.71932ZM7.61286 7.78843C7.22534 7.78843 6.9112 8.10257 6.9112 8.49009C6.9112 8.87761 7.22534 9.19175 7.61286 9.19175H10.2452C10.6327 9.19175 10.9469 8.87761 10.9469 8.49009C10.9469 8.10257 10.6327 7.78843 10.2452 7.78843H7.61286Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8083 13.7548C14.8083 13.3673 15.1224 13.0531 15.51 13.0531H16.3874C16.7749 13.0531 17.0891 13.3673 17.0891 13.7548C17.0891 14.1423 16.7749 14.4565 16.3874 14.4565H15.51C15.1224 14.4565 14.8083 14.1423 14.8083 13.7548Z"
        fill={color}
      />
    </svg>
  );
};

// icon - payout
export const IconPayout = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.61003 9.1655C12.1389 9.1655 14.9175 7.66506 14.9175 5.72003C14.9175 3.77501 12.1389 2.21899 8.61003 2.21899C5.0812 2.21899 2.21924 3.8028 2.21924 5.72003C2.21924 7.63727 5.05341 9.1655 8.61003 9.1655Z"
        fill={color}
      />
      <path
        d="M2.21924 15.1118V16.0565C2.21924 17.9737 5.05341 19.502 8.61003 19.502C8.80453 19.502 8.99903 19.4742 9.19353 19.4742C8.74896 18.7795 8.41552 18.0293 8.22102 17.1957C5.66471 17.1124 3.44182 16.3344 2.21924 15.1118Z"
        fill={color}
      />
      <path
        d="M8.0543 16.0287C8.0543 15.862 8.02652 15.6675 8.02652 15.473C8.02652 14.8895 8.10988 14.306 8.24881 13.7503C5.66471 13.6669 3.46961 12.8889 2.21924 11.6663V12.611C2.21924 14.4449 4.77555 15.862 8.0543 16.0287Z"
        fill={color}
      />
      <path
        d="M8.61002 12.611C8.99903 11.6941 9.52696 10.8883 10.2216 10.2214C9.69368 10.277 9.16575 10.3048 8.61002 10.3048C5.88699 10.3048 3.52518 9.49899 2.21924 8.22084V9.16556C2.21924 11.1106 5.05341 12.611 8.61002 12.611Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7811 15.4734C21.7811 18.9569 18.9572 21.7809 15.4737 21.7809C11.9902 21.7809 9.16624 18.9569 9.16624 15.4734C9.16624 11.9899 11.9902 9.166 15.4737 9.166C18.9572 9.166 21.7811 11.9899 21.7811 15.4734ZM15.5432 11.3276C15.7522 11.3276 15.9612 11.5366 15.9612 11.7457V12.2334H17.2154C17.4245 12.2334 17.6335 12.4424 17.6335 12.6515V12.7908C17.6335 12.9999 17.4245 13.2089 17.2154 13.2089H14.498C14.289 13.2089 14.08 13.3482 13.9406 13.4876C13.7316 13.6966 13.6619 13.9057 13.6619 14.1147C13.6619 14.3237 13.8012 14.5328 13.9406 14.6721C14.08 14.8115 14.289 14.9508 14.498 14.9508H16.3793C16.8671 14.9508 17.3708 15.1112 17.7385 15.4947C18.0507 15.8203 18.2606 16.2747 18.2606 16.7624C18.2606 17.2502 18.1212 17.6683 17.8425 18.0166C17.5638 18.365 17.0761 18.5741 16.5883 18.5741H16.1006V19.2012C16.1006 19.4102 15.8916 19.6192 15.6825 19.6192H15.4735C15.2645 19.6192 15.0554 19.4102 15.0554 19.2012V18.5741H13.5225C13.3135 18.5741 13.1045 18.365 13.1045 18.156V17.947C13.1045 17.7379 13.2438 17.5986 13.4529 17.5986H16.3793C16.658 17.5986 16.8671 17.5289 17.0064 17.4592C17.2154 17.2502 17.2851 17.0412 17.2851 16.8321C17.2851 16.5534 17.1458 16.3444 17.0064 16.205C16.7974 15.996 16.5883 15.9263 16.3793 15.9263H14.498C14.08 15.9263 13.5922 15.7173 13.2438 15.3689C12.8954 15.0902 12.6864 14.6024 12.6864 14.1147C12.6864 13.627 12.8954 13.1392 13.2438 12.8605C13.5225 12.5121 14.0103 12.3031 14.498 12.3031H14.9858V11.7457C14.9858 11.5366 15.1251 11.3276 15.3341 11.3276H15.5432Z"
        fill={color}
      />
    </svg>
  );
};

// icon -list transfer
export const IconListTransfer = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.76984 3.01514C7.41041 3.01514 7.11903 3.30593 7.11903 3.66464C7.11903 4.02336 7.41041 4.31415 7.76984 4.31415H18.3998L18.3998 16.6548C18.3998 17.0135 18.6912 17.3043 19.0506 17.3043C19.4101 17.3043 19.7014 17.0135 19.7014 16.6548V4.31415C19.7014 3.59673 19.1187 3.01514 18.3998 3.01514H7.76984Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29883 6.69569C4.29883 5.97826 4.88159 5.39667 5.60046 5.39667H16.0135C16.7324 5.39667 17.3151 5.97826 17.3151 6.69569V19.6858C17.3151 20.4033 16.7324 20.9849 16.0135 20.9849H5.60046C4.88159 20.9849 4.29883 20.4033 4.29883 19.6858V6.69569ZM7.71826 9.72507C7.71826 9.36636 8.00964 9.07556 8.36908 9.07556H13.2502C13.6096 9.07556 13.901 9.36636 13.901 9.72507C13.901 10.0838 13.6096 10.3746 13.2502 10.3746H8.36908C8.00964 10.3746 7.71826 10.0838 7.71826 9.72507ZM8.36908 12.5396C8.00964 12.5396 7.71826 12.8304 7.71826 13.1891C7.71826 13.5478 8.00964 13.8386 8.36908 13.8386H13.2502C13.6096 13.8386 13.901 13.5478 13.901 13.1891C13.901 12.8304 13.6096 12.5396 13.2502 12.5396H8.36908ZM7.71826 16.6532C7.71826 16.2945 8.00964 16.0037 8.36908 16.0037H13.2502C13.6096 16.0037 13.901 16.2945 13.901 16.6532C13.901 17.0119 13.6096 17.3027 13.2502 17.3027H8.36908C8.00964 17.3027 7.71826 17.0119 7.71826 16.6532Z"
        fill={color}
      />
    </svg>
  );
};

// icon - customer
export const IconCustomer = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37528 7.37547C7.37528 4.82143 9.44574 2.75098 11.9998 2.75098C14.5538 2.75098 16.6243 4.82143 16.6243 7.37547C16.6243 9.92951 14.5538 12 11.9998 12C9.44574 12 7.37528 9.92951 7.37528 7.37547Z"
        fill={color}
      />
      <path
        d="M13.8496 13.8498H10.15C7.08513 13.8498 4.60059 16.3343 4.60059 19.3992V19.8616C4.60059 20.6278 5.22172 21.249 5.98793 21.249H18.0116C18.7778 21.249 19.399 20.6278 19.399 19.8616V19.3992C19.399 16.3343 16.9144 13.8498 13.8496 13.8498Z"
        fill={color}
      />
    </svg>
  );
};

// icon - statistic
export const IconStatistic = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10848 8.30526H4.46797C3.90404 8.30526 3.44265 8.72226 3.44265 9.23192V17.2197C3.44265 17.7294 3.90404 18.1464 4.46797 18.1464H6.10848C6.6724 18.1464 7.1338 17.7294 7.1338 17.2197V9.23192C7.1338 8.71299 6.6724 8.30526 6.10848 8.30526Z"
        fill={color}
      />
      <path
        d="M12.7267 5.34929H11.1194C10.5668 5.34929 10.1148 5.76629 10.1148 6.27595V17.2198C10.1148 17.7295 10.5668 18.1465 11.1194 18.1465H12.7267C13.2792 18.1465 13.7313 17.7295 13.7313 17.2198V6.27595C13.7313 5.76629 13.2792 5.34929 12.7267 5.34929Z"
        fill={color}
      />
      <path
        d="M19.5025 2.39282H17.8311C17.2565 2.39282 16.7864 2.80982 16.7864 3.31948V17.2194C16.7864 17.7291 17.2565 18.1461 17.8311 18.1461H19.5025C20.0771 18.1461 20.5472 17.7291 20.5472 17.2194V3.31948C20.5472 2.80982 20.0771 2.39282 19.5025 2.39282Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.40234 20.5489C3.40234 19.9644 3.87615 19.4906 4.46062 19.4906L19.5393 19.4906C20.1238 19.4906 20.5976 19.9644 20.5976 20.5489C20.5976 21.1334 20.1238 21.6072 19.5393 21.6072L4.46062 21.6072C3.87615 21.6072 3.40234 21.1334 3.40234 20.5489Z"
        fill={color}
      />
    </svg>
  );
};

// icon - support
export const IconSupport = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.29474 13.3817C7.10723 13.3817 6.00266 13.9696 5.21141 14.9543C4.42293 15.9355 3.99512 17.2435 3.99512 18.587V19.9869C3.99512 20.8153 4.66669 21.4869 5.49512 21.4869H18.5049C19.3333 21.4869 20.0049 20.8153 20.0049 19.9869V18.587C20.0049 17.2435 19.5771 15.9355 18.7886 14.9543C17.9973 13.9696 16.8928 13.3817 15.7053 13.3817H8.29474Z"
        fill={color}
      />
      <path
        d="M12.1972 4.68725C10.0682 4.68725 8.34233 6.41314 8.34233 8.54212C8.34233 10.6711 10.0682 12.397 12.1972 12.397C14.3262 12.397 16.0521 10.6711 16.0521 8.54212C16.0521 6.41314 14.3262 4.68725 12.1972 4.68725Z"
        fill={color}
      />
      <path
        d="M12.1976 3.70191C10.914 3.70191 9.68295 4.21182 8.77531 5.11946C8.39384 5.50093 8.08262 5.93952 7.84999 6.41515V11.8024H6.01595C5.22813 11.8024 4.58948 11.1637 4.58948 10.3759V7.79466C4.58948 7.00684 5.22813 6.36819 6.01595 6.36819H6.57449C6.87453 5.59199 7.33491 4.87874 7.93475 4.2789C9.06532 3.14833 10.5987 2.51318 12.1976 2.51318C13.7964 2.51318 15.3298 3.14833 16.4604 4.2789C17.058 4.87646 17.5171 5.58658 17.8172 6.35936C17.8184 6.3623 17.8195 6.36524 17.8206 6.36819H18.3786C19.1664 6.36819 19.805 7.00684 19.805 7.79466V10.3759C19.805 11.1637 19.1664 11.8024 18.3786 11.8024H16.5445V6.41387C16.312 5.93873 16.001 5.50059 15.6198 5.11946C14.7122 4.21182 13.4812 3.70191 12.1976 3.70191Z"
        fill={color}
      />
    </svg>
  );
};

// icon - setting
export const IconSetting = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2801 12.49V11.5036L20.5514 10.4205C20.7857 10.2194 20.9395 9.94413 20.9855 9.6433C21.0316 9.34247 20.9669 9.03549 20.803 8.77659L19.2403 6.19786C19.1242 6.00205 18.9573 5.8394 18.7562 5.72625C18.5551 5.6131 18.3271 5.55341 18.0948 5.55318C17.9509 5.5521 17.8078 5.57388 17.6711 5.61765L16.0621 6.14629C15.7843 5.96655 15.4945 5.80503 15.1947 5.66277L14.857 4.03818C14.7964 3.74137 14.6306 3.47475 14.3885 3.28499C14.1464 3.09524 13.8435 2.99444 13.5327 3.00024H10.4339C10.1232 2.99444 9.82024 3.09524 9.57814 3.28499C9.33603 3.47475 9.17019 3.74137 9.10964 4.03818L8.77195 5.66277C8.46997 5.80499 8.178 5.96652 7.89793 6.14629L6.32205 5.59186C6.18386 5.5568 6.04076 5.54374 5.89828 5.55318C5.66605 5.55341 5.43797 5.6131 5.23692 5.72625C5.03586 5.8394 4.8689 6.00205 4.75279 6.19786L3.19014 8.77659C3.03559 9.0351 2.97816 9.33789 3.02769 9.63309C3.07721 9.9283 3.23062 10.1976 3.46162 10.3947L4.71306 11.51V12.4964L3.46162 13.5795C3.22409 13.778 3.06649 14.0521 3.0168 14.3531C2.9671 14.654 3.02851 14.9624 3.19014 15.2234L4.75279 17.8021C4.8689 17.998 5.03586 18.1606 5.23692 18.2737C5.43797 18.3869 5.66605 18.4466 5.89828 18.4468C6.0422 18.4479 6.18533 18.4261 6.32205 18.3824L7.93104 17.8537C8.20883 18.0334 8.49861 18.195 8.79844 18.3372L9.13613 19.9618C9.19668 20.2586 9.36252 20.5253 9.60462 20.715C9.84672 20.9048 10.1497 21.0056 10.4604 20.9998H13.5857C13.8964 21.0056 14.1994 20.9048 14.4415 20.715C14.6836 20.5253 14.8494 20.2586 14.91 19.9618L15.2476 18.3372C15.5496 18.195 15.8416 18.0335 16.1217 17.8537L17.724 18.3824C17.8608 18.4261 18.0039 18.4479 18.1478 18.4468C18.38 18.4466 18.6081 18.3869 18.8092 18.2737C19.0102 18.1606 19.1772 17.998 19.2933 17.8021L20.803 15.2234C20.9575 14.9649 21.015 14.6621 20.9654 14.3669C20.9159 14.0717 20.7625 13.8024 20.5315 13.6053L19.2801 12.49ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        fill={color}
      />
    </svg>
  );
};

// icon - note
export const IconNote = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.45723C4 2.65243 4.64384 2 5.43806 2H17.9012C18.6955 2 19.3393 2.65243 19.3393 3.45723V14.8722H15.2648C14.4706 14.8722 13.8267 15.5247 13.8267 16.3295V21.4298H5.43806C4.64384 21.4298 4 20.7774 4 19.9725V3.45723ZM8.79353 7.10032C8.39642 7.10032 8.0745 7.42653 8.0745 7.82893C8.0745 8.23134 8.39642 8.55755 8.79353 8.55755H14.5458C14.9429 8.55755 15.2648 8.23134 15.2648 7.82893C15.2648 7.42653 14.9429 7.10032 14.5458 7.10032H8.79353ZM8.0745 11.7149C8.0745 11.3125 8.39642 10.9863 8.79353 10.9863H14.5458C14.9429 10.9863 15.2648 11.3125 15.2648 11.7149C15.2648 12.1173 14.9429 12.4435 14.5458 12.4435H8.79353C8.39642 12.4435 8.0745 12.1173 8.0745 11.7149ZM8.79353 14.8722C8.39642 14.8722 8.0745 15.1984 8.0745 15.6008C8.0745 16.0032 8.39642 16.3295 8.79353 16.3295H10.7109C11.1081 16.3295 11.43 16.0032 11.43 15.6008C11.43 15.1984 11.1081 14.8722 10.7109 14.8722H8.79353Z"
        fill={color}
      />
      <path
        d="M15.2648 16.3295H18.7754L15.2648 20.8651V16.3295Z"
        fill={color}
      />
    </svg>
  );
};

// icon - POS
export const IconPos = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3418 3.69843V7.34052C17.3418 7.5337 17.265 7.71898 17.1284 7.85558C16.9918 7.99219 16.8065 8.06893 16.6133 8.06893H7.38681C7.19363 8.06893 7.00835 7.99219 6.87174 7.85558C6.73514 7.71898 6.6584 7.5337 6.6584 7.34052V3.69843C6.07903 3.69909 5.52359 3.92953 5.11392 4.33921C4.70425 4.74888 4.47381 5.30432 4.47314 5.88368V20.549C4.47314 21.1286 4.70338 21.6844 5.11319 22.0942C5.523 22.504 6.07883 22.7343 6.6584 22.7343H17.3418C17.9213 22.7343 18.4771 22.504 18.887 22.0942C19.2968 21.6844 19.527 21.1286 19.527 20.549V5.88368C19.5263 5.30432 19.2959 4.74888 18.8862 4.33921C18.4766 3.92953 17.9211 3.69909 17.3418 3.69843ZM8.6011 17.7287H7.62988C7.43669 17.7287 7.25142 17.652 7.11481 17.5154C6.97821 17.3788 6.90146 17.1935 6.90146 17.0003C6.90146 16.8071 6.97821 16.6218 7.11481 16.4852C7.25142 16.3486 7.43669 16.2719 7.62988 16.2719H8.6011C8.79429 16.2719 8.97957 16.3486 9.11617 16.4852C9.25278 16.6218 9.32952 16.8071 9.32952 17.0003C9.32952 17.1935 9.25278 17.3788 9.11617 17.5154C8.97957 17.652 8.79429 17.7287 8.6011 17.7287ZM11.5141 17.7287H12.4853C12.6785 17.7287 12.8638 17.652 13.0004 17.5154C13.137 17.3788 13.2137 17.1935 13.2137 17.0003C13.2137 16.8071 13.137 16.6218 13.0004 16.4852C12.8638 16.3486 12.6785 16.2719 12.4853 16.2719H11.5141C11.3209 16.2719 11.1356 16.3486 10.999 16.4852C10.8624 16.6218 10.7857 16.8071 10.7857 17.0003C10.7857 17.1935 10.8624 17.3788 10.999 17.5154C11.1356 17.652 11.3209 17.7287 11.5141 17.7287ZM16.3705 17.7287H15.3993C15.2061 17.7287 15.0208 17.652 14.8842 17.5154C14.7476 17.3788 14.6709 17.1935 14.6709 17.0003C14.6709 16.8071 14.7476 16.6218 14.8842 16.4852C15.0208 16.3486 15.2061 16.2719 15.3993 16.2719H16.3705C16.5637 16.2719 16.749 16.3486 16.8856 16.4852C17.0222 16.6218 17.0989 16.8071 17.0989 17.0003C17.0989 17.1935 17.0222 17.3788 16.8856 17.5154C16.749 17.652 16.5637 17.7287 16.3705 17.7287ZM7.62988 9.51716H16.3708C16.7731 9.51716 17.0992 9.84328 17.0992 10.2456V13.1591C17.0992 13.5614 16.7731 13.8876 16.3708 13.8876H7.62988C7.22759 13.8876 6.90146 13.5614 6.90146 13.1591V10.2456C6.90146 9.84328 7.22759 9.51716 7.62988 9.51716Z"
        fill={color}
      />
      <path
        d="M7.83114 6.78797H16.1698V1.99825C16.1717 1.80572 16.0971 1.62031 15.9623 1.48283C15.8275 1.34534 15.6436 1.26704 15.451 1.26514H8.55006C8.35751 1.26704 8.1736 1.34534 8.03879 1.48282C7.90397 1.6203 7.82928 1.80571 7.83114 1.99825V6.78797Z"
        fill={color}
      />
      <path d="M8.0057 10.6834H15.995V12.7215H8.0057V10.6834Z" fill={color} />
    </svg>
  );
};

export const IconArrow = ({ color = "#8E9ABB" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.21967 7.20921C9.51256 6.93026 9.98744 6.93026 10.2803 7.20921L14.7803 11.4949C15.0732 11.7739 15.0732 12.2261 14.7803 12.5051L10.2803 16.7908C9.98744 17.0697 9.51256 17.0697 9.21967 16.7908C8.92678 16.5118 8.92678 16.0596 9.21967 15.7806L13.1893 12L9.21967 8.21936C8.92678 7.94042 8.92678 7.48816 9.21967 7.20921Z"
        fill={color}
      />
    </svg>
  );
};

export const IconArrowLeft = ({ color = "#8E9ABB" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7803 7.20921C14.4874 6.93026 14.0126 6.93026 13.7197 7.20921L9.21967 11.4949C8.92678 11.7739 8.92678 12.2261 9.21967 12.5051L13.7197 16.7908C14.0126 17.0697 14.4874 17.0697 14.7803 16.7908C15.0732 16.5118 15.0732 16.0596 14.7803 15.7806L10.8107 12L14.7803 8.21936C15.0732 7.94042 15.0732 7.48816 14.7803 7.20921Z"
        fill={color}
      />
    </svg>
  );
};

export const IconClose = ({ color = "#1F2A37" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0976 17.3166 18.0976 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711C18.0976 7.31658 18.0976 6.68342 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L10.5858 12L6.29289 16.2929Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCopy = ({ color = "#8E9ABB" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6925 6.46317H5.5884C5.2263 6.46358 4.87915 6.60761 4.6231 6.86365C4.36706 7.1197 4.22303 7.46685 4.22263 7.82895V18.9333C4.22303 19.2955 4.36706 19.6426 4.6231 19.8986C4.87915 20.1547 5.2263 20.2987 5.5884 20.2991H14.6925C15.0546 20.2987 15.4018 20.1547 15.6578 19.8986C15.9139 19.6426 16.0579 19.2955 16.0583 18.9333V7.82895C16.0579 7.46685 15.9139 7.1197 15.6578 6.86365C15.4018 6.60761 15.0546 6.46358 14.6925 6.46317Z"
        fill="#e51c00"
      />
      <path
        d="M18.4119 17.5368H17.3104C17.2779 17.5369 17.2455 17.5338 17.2136 17.5276V6.67518C17.2132 6.31281 17.069 5.96543 16.8126 5.70934C16.5562 5.45325 16.2087 5.30941 15.8463 5.30941H7.99886C7.96116 5.23407 7.94168 5.15092 7.94201 5.06667C7.94242 4.70457 8.08645 4.35742 8.34249 4.10137C8.59853 3.84533 8.94569 3.7013 9.30779 3.7009H18.4119C18.7741 3.7009 19.1215 3.84479 19.3777 4.10092C19.6338 4.35706 19.7777 4.70444 19.7777 5.06667V16.1711C19.7777 16.5333 19.6338 16.8807 19.3777 17.1368C19.1215 17.393 18.7741 17.5368 18.4119 17.5368Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCheck = ({ color = "#8E9ABB" }: { color: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4592 7.18146C18.9409 7.46468 19.1018 8.08477 18.8185 8.56646L13.0017 18.4594C12.8305 18.7506 12.5252 18.9371 12.1879 18.9566C11.8506 18.9761 11.5259 18.826 11.3222 18.5564L7.24613 13.1602C6.90932 12.7144 6.99774 12.0799 7.44362 11.7431C7.88949 11.4063 8.52398 11.4947 8.86079 11.9406L12.0246 16.1289L17.0742 7.54082C17.3574 7.05912 17.9775 6.89823 18.4592 7.18146Z"
        fill={color}
      />
    </svg>
  );
};

export const IconEdit = ({ color = "#8E9ABB" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4506 10.1724L16.1809 12.4641C16.0907 12.5552 15.9777 12.6198 15.854 12.651L12.0534 13.6104C11.8136 13.6709 11.5599 13.6 11.3851 13.4235C11.2103 13.247 11.1401 12.9909 11.2 12.7487L11.304 12.3289L6.25309 12.3289C5.79967 12.3289 5.4321 11.9578 5.4321 11.5C5.4321 11.0422 5.79967 10.6711 6.25309 10.6711L11.7145 10.6711L12.1502 8.9113C12.1811 8.78637 12.2451 8.67227 12.3353 8.58121L12.8458 8.06579L6.25309 8.06579C5.79967 8.06579 5.4321 7.69466 5.4321 7.23684C5.4321 6.77903 5.79967 6.40789 6.25309 6.40789L14.4877 6.4079L17.8539 3.00906C17.5187 2.69325 17.0687 2.5 16.5741 2.5H4.37654C3.34016 2.5 2.5 3.3483 2.5 4.39474V19.6053C2.5 20.6517 3.34016 21.5 4.37654 21.5H16.5741C17.6105 21.5 18.4506 20.6517 18.4506 19.6053V10.1724ZM5.4321 15.7632C5.4321 15.3053 5.79967 14.9342 6.25309 14.9342L10.0062 14.9342C10.4596 14.9342 10.8272 15.3053 10.8272 15.7632C10.8272 16.221 10.4596 16.5921 10.0062 16.5921L6.25309 16.5921C5.79967 16.5921 5.4321 16.221 5.4321 15.7632Z"
        fill="white"
      />
      <path
        d="M20.1881 3.21053C19.8402 3.21053 19.5065 3.35008 19.2605 3.59849L13.652 9.26134C13.5318 9.38275 13.4465 9.53488 13.4052 9.70146L12.9447 11.5616C12.9017 11.735 13.0573 11.8922 13.2291 11.8488L15.0714 11.3838C15.2364 11.3421 15.387 11.256 15.5073 11.1346L21.1158 5.47172C21.3618 5.22331 21.5 4.8864 21.5 4.5351C21.5 4.1838 21.3618 3.84689 21.1158 3.59849C20.8697 3.35008 20.5361 3.21053 20.1881 3.21053Z"
        fill="white"
      />
    </svg>
  );
};

export const IconTrash = ({ color = "red" }: { color: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8555 4.53516H15.4588L15.0874 3.4216C14.8537 2.72086 14.2003 2.25 13.4617 2.25H10.5383C9.79962 2.25 9.14634 2.72086 8.91203 3.4216L8.54111 4.53516H5.14453C4.19947 4.53516 3.43066 5.30396 3.43066 6.24902V7.3916C3.43066 8.02794 4.00351 7.96289 4.6183 7.96289C9.89526 7.96289 14.6797 7.96289 19.998 7.96289C20.3138 7.96289 20.5693 7.70737 20.5693 7.3916V6.24902C20.5693 5.30396 19.8005 4.53516 18.8555 4.53516ZM9.74581 4.53516L9.99603 3.78311C10.0741 3.54934 10.2923 3.39258 10.5383 3.39258H13.4617C13.7077 3.39258 13.9259 3.54934 14.0034 3.78311L14.2539 4.53516H9.74581Z"
        fill={color}
      />
      <path
        d="M4.71287 9.18164L5.62377 20.1912C5.70467 21.0799 6.43832 21.75 7.3304 21.75H16.6696C17.5617 21.75 18.2954 21.0799 18.3768 20.1862L19.2872 9.18164H4.71287ZM9.14356 18.8935C9.14356 19.6466 8.00098 19.6497 8.00098 18.8935V10.8955C8.00098 10.1424 9.14356 10.1393 9.14356 10.8955V18.8935ZM12.5713 18.8935C12.5713 19.6466 11.4287 19.6497 11.4287 18.8935V10.8955C11.4287 10.1424 12.5713 10.1393 12.5713 10.8955V18.8935ZM15.999 18.8935C15.999 19.6466 14.8565 19.6497 14.8565 18.8935V10.8955C14.8565 10.5797 15.112 10.3242 15.4277 10.3242C15.7435 10.3242 15.999 10.5797 15.999 10.8955V18.8935Z"
        fill={color}
      />
    </svg>
  );
};
export const IconEmail = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10.0507V18C2 18.8284 2.67157 19.5 3.5 19.5H20.5C21.3284 19.5 22 18.8284 22 18V10.0507L13.2907 13.0198C12.4539 13.305 11.5461 13.305 10.7093 13.0198L2 10.0507Z"
        fill={color}
      />
      <path
        d="M22 8.46591V6C22 5.17157 21.3284 4.5 20.5 4.5H3.5C2.67157 4.5 2 5.17157 2 6V8.46591L10.7093 11.435C11.5461 11.7203 12.4539 11.7203 13.2907 11.435L22 8.46591Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPhone = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.44482 6.16736C5.44482 4.28174 5.44482 3.33893 6.03061 2.75315C6.6164 2.16736 7.55921 2.16736 9.44482 2.16736H14.555C16.4406 2.16736 17.3834 2.16736 17.9692 2.75315C18.555 3.33893 18.555 4.28174 18.555 6.16736V17.8326C18.555 19.7183 18.555 20.6611 17.9692 21.2469C17.3834 21.8326 16.4406 21.8326 14.555 21.8326H9.44482C7.55921 21.8326 6.6164 21.8326 6.03061 21.2469C5.44482 20.6611 5.44482 19.7183 5.44482 17.8326V6.16736ZM9.31489 4.35239C9.31489 4.07625 9.53874 3.85239 9.81489 3.85239H14.185C14.4611 3.85239 14.685 4.07625 14.685 4.35239C14.685 4.62853 14.4611 4.85239 14.185 4.85239H9.81489C9.53874 4.85239 9.31489 4.62853 9.31489 4.35239ZM11.9999 19.6476C12.6033 19.6476 13.0924 19.1585 13.0924 18.5551C13.0924 17.9517 12.6033 17.4626 11.9999 17.4626C11.3965 17.4626 10.9074 17.9517 10.9074 18.5551C10.9074 19.1585 11.3965 19.6476 11.9999 19.6476Z"
        fill={color}
      />
    </svg>
  );
};

export const IconAttachFile = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6693 4.18293C19.9553 3.46094 19.0948 3.08542 18.1777 3.09745C17.3197 3.10856 16.4779 3.47315 15.8073 4.12406L15.801 4.13019L7.09618 12.9803C6.22519 13.8605 6.22496 15.1382 7.09565 16.0186C7.51784 16.4455 8.05643 16.6806 8.6123 16.6806C9.1749 16.6805 9.7173 16.4454 10.1417 16.016L15.6259 10.4133C15.9199 10.1129 15.9148 9.63111 15.6144 9.33713C15.3141 9.04316 14.8323 9.04831 14.5383 9.34865L9.05676 14.9487C8.92297 15.0841 8.76518 15.1586 8.61234 15.1586C8.46197 15.1587 8.3157 15.0879 8.1777 14.9484C7.77711 14.5433 8.04441 14.1858 8.17956 14.0493L16.8732 5.21045C17.7041 4.40898 18.7685 4.42542 19.5872 5.25318C20.5586 6.23536 20.2875 7.38841 19.5878 8.09541L9.69215 18.3155C9.01216 19.0022 8.15182 19.3803 7.26927 19.3805C6.38701 19.3805 5.54954 19.0057 4.84836 18.2968C3.20702 16.6372 3.66544 14.6881 4.84813 13.4921L11.8094 6.53237C12.1066 6.23523 12.1067 5.75342 11.8095 5.45621C11.5124 5.15901 11.0306 5.15896 10.7334 5.45609L3.77042 12.4175L3.76757 12.4204C2.82694 13.3709 2.29181 14.5695 2.26077 15.7953C2.22763 17.1025 2.74822 18.3376 3.76631 19.367C4.74563 20.3572 5.98943 20.9025 7.26892 20.9024C8.56242 20.9023 9.80877 20.3626 10.7772 19.3828L20.6729 9.16266C22.0978 7.71959 22.0966 5.62603 20.6693 4.18293Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPositionMap = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.73695 11.2693L15.6492 7.77088C16.0094 7.64376 16.3563 7.99062 16.2291 8.3508L12.7307 18.2631C12.5972 18.6413 12.0749 18.6739 11.8955 18.3151L10.2888 15.1016L11.6792 12.3209L8.89841 13.7113L5.68496 12.1045C5.32618 11.9251 5.3587 11.4028 5.73695 11.2693Z"
        fill={color}
      />
    </svg>
  );
};

export const IconBank = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2581 3.03653L21.614 7.52465H21.6218V9.63425C21.6219 9.69913 21.6091 9.76337 21.5843 9.82331C21.5595 9.88326 21.5231 9.93772 21.4772 9.9836C21.4313 10.0295 21.3769 10.0659 21.3169 10.0907C21.257 10.1155 21.1928 10.1283 21.1279 10.1283H2.8714C2.80653 10.1283 2.74228 10.1155 2.68235 10.0907C2.62241 10.0659 2.56795 10.0295 2.52208 9.9836C2.47621 9.93772 2.43983 9.88326 2.41501 9.82331C2.39019 9.76337 2.37743 9.69913 2.37744 9.63425V7.52465H2.37867L11.7344 3.03653C11.8161 2.99738 11.9056 2.97705 11.9962 2.97705C12.0869 2.97705 12.1763 2.99738 12.2581 3.03653Z"
        fill={color}
      />
      <path
        d="M8.05303 11.1296H4.63281V17.9324H8.05303V11.1296Z"
        fill={color}
      />
      <path
        d="M13.6903 11.1296H10.3076V17.9324H13.6903V11.1296Z"
        fill={color}
      />
      <path d="M19.366 11.1296H15.9458V17.9324H19.366V11.1296Z" fill={color} />
      <path
        d="M2.47834 20.7809C2.53024 20.8556 2.59947 20.9167 2.6801 20.9589C2.76073 21.0011 2.85038 21.0231 2.94139 21.0231H21.0575C21.1486 21.0231 21.2383 21.0011 21.319 20.9588C21.3997 20.9166 21.469 20.8554 21.5209 20.7805C21.5728 20.7057 21.6058 20.6193 21.6171 20.5289C21.6283 20.4386 21.6175 20.3468 21.5855 20.2615C21.3925 19.7886 21.1232 19.3506 20.7884 18.965C20.7355 18.9032 20.6699 18.8535 20.5961 18.8195C20.5222 18.7855 20.4419 18.7678 20.3606 18.7678H3.63876C3.55745 18.7678 3.47711 18.7855 3.40327 18.8195C3.32943 18.8535 3.26383 18.9032 3.211 18.965C2.87615 19.3506 2.60685 19.7886 2.41382 20.2615C2.38179 20.3468 2.37097 20.4386 2.38228 20.5291C2.3936 20.6195 2.42627 20.7061 2.47834 20.7809Z"
        fill={color}
      />
    </svg>
  );
};

export const IconPhoneBook = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5019 19.5034V3.99973C18.5019 3.23806 17.8844 2.62061 17.1227 2.62061H6.87742C6.11575 2.62061 5.49829 3.23806 5.49829 3.99973V19.5034H4.19228C3.88761 19.5034 3.64062 19.7504 3.64062 20.055V20.8276C3.64062 21.1323 3.88761 21.3792 4.19228 21.3792H19.8078C20.1125 21.3792 20.3595 21.1323 20.3595 20.8276V20.055C20.3595 19.7504 20.1125 19.5034 19.8078 19.5034H18.5019ZM11.0712 4.95619C11.0712 4.7023 11.2771 4.49648 11.531 4.49648H12.4692C12.7231 4.49648 12.9289 4.7023 12.9289 4.95619V5.91265C12.9289 6.16654 12.7231 6.37236 12.4692 6.37236H11.531C11.2771 6.37236 11.0712 6.16654 11.0712 5.91265V4.95619ZM11.0712 8.7079C11.0712 8.45401 11.2771 8.24819 11.531 8.24819H12.4692C12.7231 8.24819 12.9289 8.45401 12.9289 8.7079V9.66436C12.9289 9.91825 12.7231 10.1241 12.4692 10.1241H11.531C11.2771 10.1241 11.0712 9.91825 11.0712 9.66436V8.7079ZM11.0712 12.4596C11.0712 12.2057 11.2771 11.9999 11.531 11.9999H12.4692C12.7231 11.9999 12.9289 12.2057 12.9289 12.4596V13.4161C12.9289 13.67 12.7231 13.8758 12.4692 13.8758H11.531C11.2771 13.8758 11.0712 13.67 11.0712 13.4161V12.4596ZM9.21358 13.4161C9.21358 13.67 9.00776 13.8758 8.75387 13.8758H7.81562C7.56173 13.8758 7.35591 13.67 7.35591 13.4161V12.4596C7.35591 12.2057 7.56173 11.9999 7.81562 11.9999H8.75387C9.00776 11.9999 9.21358 12.2057 9.21358 12.4596V13.4161ZM9.21358 9.66436C9.21358 9.91825 9.00776 10.1241 8.75387 10.1241H7.81562C7.56173 10.1241 7.35591 9.91825 7.35591 9.66436V8.7079C7.35591 8.45401 7.56173 8.24819 7.81562 8.24819H8.75387C9.00776 8.24819 9.21358 8.45401 9.21358 8.7079V9.66436ZM9.21358 5.91261C9.21358 6.1665 9.00776 6.37232 8.75387 6.37232H7.81562C7.56173 6.37232 7.35591 6.1665 7.35591 5.91261V4.95619C7.35591 4.7023 7.56173 4.49648 7.81562 4.49648H8.75387C9.00776 4.49648 9.21358 4.7023 9.21358 4.95619V5.91261ZM13.8577 19.5034H10.1424V17.6275C10.1424 16.5958 10.9784 15.7516 12.0001 15.7516C13.0218 15.7516 13.8577 16.5958 13.8577 17.6275V19.5034ZM16.6442 13.4161C16.6442 13.67 16.4384 13.8758 16.1845 13.8758H15.2462C14.9923 13.8758 14.7865 13.67 14.7865 13.4161V12.4596C14.7865 12.2057 14.9923 11.9999 15.2462 11.9999H16.1845C16.4384 11.9999 16.6442 12.2057 16.6442 12.4596V13.4161ZM16.6442 9.66436C16.6442 9.91825 16.4384 10.1241 16.1845 10.1241H15.2462C14.9923 10.1241 14.7865 9.91825 14.7865 9.66436V8.7079C14.7865 8.45401 14.9923 8.24819 15.2462 8.24819H16.1845C16.4384 8.24819 16.6442 8.45401 16.6442 8.7079V9.66436ZM16.6442 5.91261C16.6442 6.1665 16.4384 6.37232 16.1845 6.37232H15.2462C14.9923 6.37232 14.7865 6.1665 14.7865 5.91261V4.95619C14.7865 4.7023 14.9923 4.49648 15.2462 4.49648H16.1845C16.4384 4.49648 16.6442 4.7023 16.6442 4.95619V5.91261Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCard48 = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43 17.8138V14.6396C43 14.1201 42.8977 13.6056 42.6989 13.1257C42.5001 12.6457 42.2087 12.2096 41.8414 11.8422C41.474 11.4749 41.0379 11.1835 40.5579 10.9847C40.0779 10.7859 39.5635 10.6836 39.044 10.6836H8.956C7.9068 10.6836 6.90058 11.1004 6.15869 11.8423C5.41679 12.5842 5 13.5904 5 14.6396V17.8138H43Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20.7876V33.3608C5 34.41 5.41679 35.4162 6.15869 36.1581C6.90058 36.9 7.9068 37.3168 8.956 37.3168H39.044C39.5635 37.3168 40.0779 37.2145 40.5579 37.0157C41.0379 36.8169 41.474 36.5255 41.8414 36.1582C42.2087 35.7908 42.5001 35.3547 42.6989 34.8747C42.8977 34.3947 43 33.8803 43 33.3608V20.7876H5ZM16.21 31.0802C16.21 30.9116 16.2432 30.7446 16.3078 30.5888C16.3723 30.4331 16.4669 30.2915 16.5861 30.1723C16.7053 30.0531 16.8469 29.9586 17.0027 29.8941C17.1585 29.8295 17.3254 29.7964 17.494 29.7964H25.3498C25.6876 29.8006 26.01 29.9377 26.2474 30.178C26.4847 30.4184 26.6178 30.7425 26.6178 31.0803C26.6178 31.418 26.4847 31.7422 26.2474 31.9825C26.01 32.2228 25.6876 32.36 25.3498 32.3642H17.494C17.3254 32.3642 17.1584 32.331 17.0026 32.2665C16.8468 32.202 16.7053 32.1074 16.586 31.9882C16.4668 31.8689 16.3722 31.7274 16.3077 31.5716C16.2432 31.4158 16.21 31.2488 16.21 31.0802ZM10.2179 29.8895C10.3756 29.8259 10.5443 29.7942 10.7142 29.7964H13.2848C13.4548 29.7942 13.6234 29.8259 13.7811 29.8895C13.9387 29.953 14.0821 30.0473 14.2031 30.1667C14.324 30.2861 14.42 30.4284 14.4856 30.5852C14.5511 30.742 14.5848 30.9103 14.5848 31.0803C14.5848 31.2502 14.5511 31.4185 14.4856 31.5753C14.42 31.7322 14.324 31.8744 14.2031 31.9938C14.0821 32.1133 13.9387 32.2075 13.7811 32.2711C13.6234 32.3346 13.4548 32.3663 13.2848 32.3642H10.7142C10.5443 32.3663 10.3756 32.3346 10.2179 32.2711C10.0603 32.2075 9.91687 32.1133 9.79594 31.9938C9.67501 31.8744 9.57899 31.7322 9.51346 31.5753C9.44793 31.4185 9.41418 31.2502 9.41418 31.0803C9.41418 30.9103 9.44793 30.742 9.51346 30.5852C9.57899 30.4284 9.67501 30.2861 9.79594 30.1667C9.91687 30.0473 10.0603 29.953 10.2179 29.8895Z"
        fill={color}
      />
    </svg>
  );
};

export const IconAmountIn = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.281 13.754C20.6287 13.1011 18.1519 10.6874 18.1519 9.7913C18.1519 9.11228 18.4962 8.5042 19.0025 8.13935C17.8278 7.58194 16.5114 7.25763 15.1139 7.25763C10.081 7.25763 6 11.3419 6 16.3788C6 21.4158 10.081 25.5001 15.1139 25.5001C20.1468 25.5001 24.2278 21.4158 24.2278 16.3788C24.2278 15.5377 24.1063 14.7269 23.8937 13.9567C23.1038 14.5343 21.9899 14.4735 21.281 13.754ZM18.4051 20.2503C17.8987 20.757 17.2203 21.0307 16.5114 21.0307H15.8329V21.7913C15.8329 22.1884 15.511 22.5103 15.1139 22.5103C14.7168 22.5103 14.3949 22.1884 14.3949 21.7913V21.0307H12.3297C11.9323 21.0307 11.6101 20.7085 11.6101 20.3111C11.6101 19.9137 11.9323 19.5915 12.3297 19.5915H16.5114C16.8354 19.5915 17.1595 19.4598 17.3924 19.2267C17.6253 18.9936 17.757 18.6794 17.757 18.345C17.757 18.0207 17.6253 17.6964 17.3924 17.4633C17.1595 17.2302 16.8456 17.0984 16.5114 17.0984H13.7165C13.0076 17.0984 12.3291 16.8146 11.8228 16.318C11.3165 15.8113 11.043 15.1323 11.043 14.4229C11.043 13.7134 11.3266 13.0344 11.8228 12.5277C12.3291 12.0209 13.0076 11.7473 13.7165 11.7473H14.3949V11.0981C14.3949 10.701 14.7168 10.3791 15.1139 10.3791C15.511 10.3791 15.8329 10.701 15.8329 11.0981V11.7574H17.5539C17.9513 11.7574 18.2734 12.0796 18.2734 12.477C18.2734 12.8744 17.9513 13.1966 17.5539 13.1966H13.7165C13.3924 13.1966 13.0684 13.3283 12.8354 13.5614C12.6025 13.7945 12.4709 14.1087 12.4709 14.433C12.4709 14.7573 12.6025 15.0816 12.8354 15.3147C13.0684 15.5478 13.3823 15.6796 13.7165 15.6796H16.5114C17.2203 15.6796 17.8987 15.9633 18.4051 16.4599C18.9114 16.9667 19.1848 17.6457 19.1848 18.3551C19.1949 19.0645 18.9114 19.7436 18.4051 20.2503Z"
        fill="white"
      />
      <path
        d="M23.2456 6.72043C22.9519 6.42652 22.4658 6.42652 22.1721 6.72043L19.6405 9.2541C19.5696 9.32504 19.519 9.40612 19.4785 9.49733C19.438 9.58855 19.4177 9.68989 19.4177 9.79124C19.4177 9.89259 19.438 9.99393 19.4785 10.0851C19.5089 10.1764 19.5696 10.2574 19.6405 10.3284L22.1721 12.862C22.4658 13.156 22.9519 13.156 23.2456 12.862C23.5392 12.5681 23.5392 12.0817 23.2456 11.7878L22.0101 10.5513H25.2405C25.6557 10.5513 26 10.2068 26 9.79124C26 9.37572 25.6557 9.03114 25.2405 9.03114H22.0101L23.2456 7.79471C23.5392 7.5008 23.5392 7.01434 23.2456 6.72043Z"
        fill="white"
      />
    </svg>
  );
};

export const IconAmountOut = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill="#FD3549" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2456 6.72043C22.9519 6.42652 22.4658 6.42652 22.1722 6.72043C21.8785 7.01434 21.8785 7.5008 22.1722 7.79471L23.4076 9.03114H20.1772C19.762 9.03114 19.4177 9.37572 19.4177 9.79124C19.4177 10.2068 19.762 10.5513 20.1772 10.5513H23.4076L22.1722 11.7878C21.8785 12.0817 21.8785 12.5681 22.1722 12.862C22.4658 13.156 22.9519 13.156 23.2456 12.862L25.7772 10.3284C25.8481 10.2574 25.9089 10.1764 25.9392 10.0851C25.9797 9.99393 26 9.89259 26 9.79124C26 9.68989 25.9797 9.58855 25.9392 9.49733C25.8987 9.40612 25.8481 9.32504 25.7772 9.2541L23.2456 6.72043Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.281 13.7539C20.7544 13.2269 20.5823 12.4871 20.7544 11.8182H20.1772C19.0633 11.8182 18.1519 10.9061 18.1519 9.79124C18.1519 9.11221 18.4962 8.50413 19.0025 8.13929C17.8278 7.58188 16.5114 7.25757 15.1139 7.25757C10.081 7.25757 6 11.3418 6 16.3788C6 21.4157 10.081 25.5 15.1139 25.5C20.1468 25.5 24.2278 21.4157 24.2278 16.3788C24.2278 15.5376 24.1063 14.7268 23.8937 13.9566C23.1038 14.5343 21.9899 14.4735 21.281 13.7539ZM18.4051 20.2502C17.8987 20.757 17.2203 21.0306 16.5114 21.0306H15.8329V21.7913C15.8329 22.1884 15.511 22.5103 15.1139 22.5103C14.7168 22.5103 14.3949 22.1884 14.3949 21.7913V21.0306H12.3297C11.9323 21.0306 11.6101 20.7084 11.6101 20.311C11.6101 19.9136 11.9323 19.5915 12.3297 19.5915H16.5114C16.8354 19.5915 17.1595 19.4597 17.3924 19.2266C17.6253 18.9935 17.757 18.6794 17.757 18.3449C17.757 18.0206 17.6253 17.6963 17.3924 17.4632C17.1595 17.2301 16.8456 17.0983 16.5114 17.0983H13.7165C13.0076 17.0983 12.3291 16.8146 11.8228 16.318C11.3165 15.8112 11.043 15.1322 11.043 14.4228C11.043 13.7134 11.3266 13.0343 11.8228 12.5276C12.3291 12.0209 13.0076 11.7472 13.7165 11.7472H14.3949V11.098C14.3949 10.701 14.7168 10.3791 15.1139 10.3791C15.511 10.3791 15.8329 10.701 15.8329 11.098V11.7574H17.5539C17.9513 11.7574 18.2734 12.0795 18.2734 12.4769C18.2734 12.8743 17.9513 13.1965 17.5539 13.1965H13.7165C13.3924 13.1965 13.0684 13.3282 12.8354 13.5613C12.6025 13.7944 12.4709 14.1086 12.4709 14.4329C12.4709 14.7572 12.6025 15.0815 12.8354 15.3146C13.0684 15.5477 13.3823 15.6795 13.7165 15.6795H16.5114C17.2203 15.6795 17.8987 15.9633 18.4051 16.4599C18.9114 16.9666 19.1848 17.6456 19.1848 18.355C19.1949 19.0645 18.9114 19.7435 18.4051 20.2502Z"
        fill="white"
      />
    </svg>
  );
};

export const IconCross = ({ color = "#FFFFFF" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5.99023C13 5.43795 12.5523 4.99023 12 4.99023C11.4478 4.99023 11 5.43795 11 5.99023V11H5.99023C5.43795 11 4.99023 11.4477 4.99023 12C4.99023 12.5523 5.43795 13 5.99023 13H11V18.0098C11 18.5621 11.4478 19.0098 12 19.0098C12.5523 19.0098 13 18.5621 13 18.0098V13H18.0098C18.5621 13 19.0098 12.5523 19.0098 12C19.0098 11.4477 18.5621 11 18.0098 11H13V5.99023Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCalendar = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1143 3.89648C17.1143 3.3442 16.6665 2.89648 16.1143 2.89648C15.562 2.89648 15.1143 3.3442 15.1143 3.89648L15.1143 6.89648C15.1143 7.44877 15.562 7.89648 16.1143 7.89648C16.6665 7.89648 17.1143 7.44877 17.1143 6.89648L17.1143 3.89648Z"
        fill={color}
      />
      <path
        d="M9.11426 3.89649C9.11426 3.3442 8.66654 2.89649 8.11426 2.89649C7.56197 2.89649 7.11426 3.3442 7.11426 3.89649L7.11426 6.89648C7.11426 7.44877 7.56197 7.89648 8.11426 7.89648C8.66654 7.89648 9.11426 7.44877 9.11426 6.89648L9.11426 3.89649Z"
        fill={color}
      />
      <path
        d="M14.1143 4.83252H10.1143L10.1143 6.83252C10.1143 7.93709 9.21883 8.83252 8.11426 8.83252C7.00969 8.83252 6.11426 7.93709 6.11426 6.83252L6.11426 4.92088C5.27249 5.02253 4.72376 5.24112 4.25368 5.7112C3.46333 6.50155 3.38388 7.72516 3.37589 10.0215H20.6258C20.6257 7.26179 20.6172 6.58131 19.7471 5.7112C19.2978 5.26191 18.8362 5.04235 18.1143 4.93506L18.1143 6.83252C18.1143 7.93709 17.2188 8.83252 16.1143 8.83252C15.0097 8.83252 14.1143 7.93709 14.1143 6.83252L14.1143 4.83252Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6258 11.7715H3.375V15.1036C3.375 17.932 3.375 19.3462 4.25368 20.2249C5.13236 21.1036 6.28587 21.1036 9.1143 21.1036H15.1143C17.9427 21.1036 18.8684 21.1036 19.7471 20.2249C20.6258 19.3462 20.6258 17.932 20.6258 15.1036V11.7715ZM6.625 14.459C6.625 14.1483 6.87684 13.8965 7.1875 13.8965H8.3125C8.62316 13.8965 8.875 14.1483 8.875 14.459V15.584C8.875 15.8946 8.62316 16.1465 8.3125 16.1465H7.1875C6.87684 16.1465 6.625 15.8946 6.625 15.584V14.459ZM11.125 14.459C11.125 14.1483 11.3768 13.8965 11.6875 13.8965H12.8125C13.1232 13.8965 13.375 14.1483 13.375 14.459V15.584C13.375 15.8946 13.1232 16.1465 12.8125 16.1465H11.6875C11.3768 16.1465 11.125 15.8946 11.125 15.584V14.459ZM16.1875 13.8965C15.8768 13.8965 15.625 14.1483 15.625 14.459V15.584C15.625 15.8946 15.8768 16.1465 16.1875 16.1465H17.3125C17.6232 16.1465 17.875 15.8946 17.875 15.584V14.459C17.875 14.1483 17.6232 13.8965 17.3125 13.8965H16.1875Z"
        fill={color}
      />
    </svg>
  );
};
export const IconCheckPermission = (props: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.72222 2.5C4.39035 2.5 2.5 4.39035 2.5 6.72222V17.2778C2.5 19.6096 4.39035 21.5 6.72222 21.5H17.2778C19.6096 21.5 21.5 19.6096 21.5 17.2778V6.72222C21.5 4.39035 19.6096 2.5 17.2778 2.5H6.72222ZM17.154 8.07283C17.4049 7.64615 17.2624 7.09689 16.8357 6.84601C16.409 6.59514 15.8598 6.73765 15.6089 7.16433L11.136 14.7715L8.33361 11.0616C8.03527 10.6666 7.47325 10.5883 7.0783 10.8866C6.68335 11.185 6.60503 11.747 6.90337 12.1419L10.5139 16.9217C10.6943 17.1605 10.982 17.2935 11.2807 17.2763C11.5795 17.259 11.8499 17.0938 12.0016 16.8358L17.154 8.07283Z"
        fill={props.color ? props.color : "#e51c00"}
      />
    </svg>
  );
};
export const IconSubtractPermission = (props: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 2.5C4.29086 2.5 2.5 4.29086 2.5 6.5V17.5C2.5 19.7091 4.29086 21.5 6.5 21.5H17.5C19.7091 21.5 21.5 19.7091 21.5 17.5V6.5C21.5 4.29086 19.7091 2.5 17.5 2.5H6.5ZM16.7226 11.0662C17.2383 11.0662 17.6564 11.4843 17.6564 12C17.6564 12.5157 17.2383 12.9338 16.7226 12.9338H7.27753C6.76182 12.9338 6.34375 12.5157 6.34375 12C6.34375 11.4843 6.76182 11.0662 7.27753 11.0662H16.7226Z"
        fill={props.color ? props.color : "#B8C3E1"}
      />
    </svg>
  );
};
export const IconInfo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0703 4.92969C17.1836 3.03906 14.6719 2 12 2C9.32812 2 6.81641 3.03906 4.92969 4.92969C3.03906 6.81641 2 9.32812 2 12C2 14.6719 3.03906 17.1836 4.92969 19.0703C6.82031 20.9609 9.32812 22 12 22C14.6719 22 17.1836 20.9609 19.0703 19.0703C20.9609 17.1797 22 14.6719 22 12C22 9.32812 20.9609 6.81641 19.0703 4.92969ZM12.0001 9.71111C12.8349 9.71111 13.5117 9.03435 13.5117 8.19951C13.5117 7.36467 12.8349 6.6879 12.0001 6.6879C11.1652 6.6879 10.4885 7.36467 10.4885 8.19951C10.4885 9.03435 11.1652 9.71111 12.0001 9.71111ZM9.80205 17.6578H14.198V16.7159H13.256V11.0639H9.80205V12.0059H10.744V16.7159H9.80205V17.6578Z"
        fill="#e51c00"
      />
    </svg>
  );
};

export const IconClock = ({ color = "#e51c00" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM10.5225 7.9775C10.5225 7.43764 10.9601 7 11.5 7C12.0399 7 12.4775 7.43764 12.4775 7.9775V12.0216L15.4664 13.5161C15.9493 13.7575 16.145 14.3446 15.9036 14.8275C15.6622 15.3104 15.075 15.5061 14.5921 15.2646L11.0628 13.5C10.7317 13.3344 10.5225 12.9959 10.5225 12.6257V7.9775Z"
        fill={color}
      />
    </svg>
  );
};

export const IconCloseRound = ({ color = "#D6DFF6" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.19526 15.8047C7.93491 15.5444 7.93491 15.1223 8.19526 14.8619L11.0572 12L8.19526 9.13807C7.93491 8.87772 7.93491 8.45561 8.19526 8.19526C8.45561 7.93491 8.87772 7.93491 9.13807 8.19526L12 11.0572L14.8619 8.19526C15.1223 7.93491 15.5444 7.93491 15.8047 8.19526C16.0651 8.45561 16.0651 8.87772 15.8047 9.13807L12.9428 12L15.8047 14.8619C16.0651 15.1223 16.0651 15.5444 15.8047 15.8047C15.5444 16.0651 15.1223 16.0651 14.8619 15.8047L12 12.9428L9.13807 15.8047C8.87772 16.0651 8.45561 16.0651 8.19526 15.8047Z"
        fill={color}
      />
    </svg>
  );
};

export const IconMenuProduct = ({ color = "#D6DFF6" }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.894 10.1179C11.0905 10.1903 11.221 10.3776 11.221 10.587V20.492C11.221 20.8404 10.8736 21.0819 10.547 20.9607L3.81885 18.463C3.03501 18.1721 2.51489 17.4242 2.51489 16.5881V7.74553C2.51489 7.39759 2.86142 7.15603 3.18787 7.2764L10.894 10.1179ZM16.5414 9.18575C16.5414 9.01215 16.3689 8.89139 16.2058 8.95089L12.9997 10.1205C12.8023 10.1924 12.671 10.3801 12.671 10.5902V20.5373C12.671 20.8866 13.02 21.1282 13.347 21.0053L20.1888 18.4332C20.9686 18.1401 21.485 17.3942 21.485 16.5612V7.73969C21.485 7.39249 21.1398 7.15098 20.8136 7.26997L18.3201 8.1796C18.1228 8.25159 17.9914 8.43925 17.9914 8.64932V13.3416C17.9914 13.7608 17.73 14.1355 17.3365 14.2802L17.214 14.3252C16.8876 14.4452 16.5414 14.2036 16.5414 13.8559V9.18575ZM17.2159 6.97584C17.2714 6.99632 17.3324 6.99643 17.388 6.97614L20.1129 5.98211C20.332 5.90219 20.332 5.59232 20.1129 5.51239L12.6422 2.78713C12.1973 2.62483 11.7093 2.62567 11.2649 2.78952L9.19984 3.55097C8.98182 3.63136 8.98182 3.93971 9.19984 4.0201L17.2159 6.97584ZM3.86691 5.98135C3.64973 5.90127 3.64863 5.5945 3.86522 5.51285L6.69437 4.44643C6.75062 4.42523 6.81263 4.42501 6.86904 4.4458L14.8763 7.39833C15.0939 7.47854 15.0945 7.78601 14.8773 7.8671L12.0343 8.92842C11.9782 8.94935 11.9165 8.94947 11.8603 8.92877L3.86691 5.98135Z"
        fill={color}
      />
    </svg>
  );
};
export const IconDanger = () => {
  return (
    <svg
      width="84"
      height="76"
      viewBox="0 0 84 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.7082 1.92646C38.3152 0.992163 40.1409 0.5 41.9998 0.5C43.8587 0.5 45.6845 0.992163 47.2915 1.92646C48.8932 2.8575 50.2279 4.18581 51.1665 5.78313L51.1757 5.79896L82.2623 59.2356C83.1788 60.874 83.6625 62.7189 83.6676 64.5962C83.6727 66.4735 83.1991 68.3211 82.2915 69.9644C81.3817 71.6119 80.0569 72.9929 78.4486 73.9702C76.8343 74.9499 74.9867 75.4784 73.0986 75.5006H73.0602H10.9011C9.01323 75.4781 7.16598 74.9496 5.55191 73.9702C3.94312 72.9931 2.61799 71.6121 1.70816 69.9644C0.80058 68.3211 0.326969 66.4735 0.332072 64.5962C0.337176 62.7189 0.820825 60.874 1.73732 59.2356L1.76316 59.1902L32.8248 5.79896L32.8332 5.78313C33.7717 4.18578 35.1064 2.85745 36.7082 1.92646Z"
        fill="#FD3549"
      />
      <path
        d="M40.5183 34.01C40.9837 34.1984 41.4817 34.2928 41.9838 34.2875H42.0167C42.5187 34.2928 43.0168 34.1984 43.4821 34.01C43.9474 33.8215 44.3707 33.5426 44.7276 33.1895C45.0844 32.8364 45.3677 32.416 45.5611 31.9526C45.7544 31.4893 45.854 30.9923 45.854 30.4902C45.854 29.9882 45.7544 29.4911 45.5611 29.0278C45.3677 28.5645 45.0844 28.1441 44.7276 27.791C44.3707 27.4378 43.9474 27.159 43.4821 26.9705C43.0168 26.782 42.5187 26.6877 42.0167 26.6929H41.9838C41.4817 26.6877 40.9837 26.782 40.5183 26.9705C40.053 27.159 39.6297 27.4378 39.2728 27.791C38.916 28.1441 38.6327 28.5645 38.4394 29.0278C38.246 29.4911 38.1465 29.9882 38.1465 30.4902C38.1465 30.9923 38.246 31.4893 38.4394 31.9526C38.6327 32.416 38.916 32.8364 39.2728 33.1895C39.6297 33.5426 40.053 33.8215 40.5183 34.01Z"
        fill="white"
      />
      <path
        d="M44.6499 59.7054C45.365 59.0123 45.7823 58.0681 45.8135 57.0727V43.9893C45.7823 42.9939 45.365 42.0497 44.6499 41.3566C43.9347 40.6635 42.9779 40.2759 41.982 40.2759C40.9861 40.2759 40.0293 40.6635 39.3142 41.3566C38.599 42.0497 38.1817 42.9939 38.1506 43.9893V57.0727C38.1817 58.0681 38.599 59.0123 39.3142 59.7054C40.0293 60.3985 40.9861 60.7861 41.982 60.7861C42.9779 60.7861 43.9347 60.3985 44.6499 59.7054Z"
        fill="white"
      />
    </svg>
  );
};

export const IconPlus = ({ color }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99999 3.54175C10.3452 3.54175 10.625 3.82157 10.625 4.16675V9.37508H15.8333C16.1785 9.37508 16.4583 9.6549 16.4583 10.0001C16.4583 10.3453 16.1785 10.6251 15.8333 10.6251H10.625V15.8334C10.625 16.1786 10.3452 16.4584 9.99999 16.4584C9.65481 16.4584 9.37499 16.1786 9.37499 15.8334V10.6251H4.16666C3.82148 10.6251 3.54166 10.3453 3.54166 10.0001C3.54166 9.6549 3.82148 9.37508 4.16666 9.37508H9.37499V4.16675C9.37499 3.82157 9.65481 3.54175 9.99999 3.54175Z"
        fill={color}
      />
    </svg>
  );
};

export const IconShare = ({ color = "currentColor" }: { color: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6868_95339)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5833 3.125C13.7778 3.125 13.1249 3.77792 13.1249 4.58333C13.1249 4.77335 13.1609 4.95344 13.226 5.11823C13.4397 5.66006 13.9677 6.04167 14.5833 6.04167C15.3887 6.04167 16.0416 5.38875 16.0416 4.58333C16.0416 3.77792 15.3887 3.125 14.5833 3.125ZM11.8749 4.58333C11.8749 3.08756 13.0875 1.875 14.5833 1.875C16.079 1.875 17.2916 3.08756 17.2916 4.58333C17.2916 6.0791 16.079 7.29167 14.5833 7.29167C13.6993 7.29167 12.9152 6.86834 12.4211 6.2144L7.91388 8.95049C8.04976 9.27348 8.12492 9.62828 8.12492 10C8.12492 10.3856 8.04405 10.7529 7.89847 11.0854L12.485 13.7043C12.9812 13.0969 13.7365 12.7083 14.5833 12.7083C16.079 12.7083 17.2916 13.9209 17.2916 15.4167C17.2916 16.9124 16.079 18.125 14.5833 18.125C13.0875 18.125 11.8749 16.9124 11.8749 15.4167C11.8749 15.2161 11.8968 15.0203 11.9384 14.8316L7.13822 12.0907C6.67057 12.4761 6.07056 12.7083 5.41659 12.7083C3.92081 12.7083 2.70825 11.4958 2.70825 10C2.70825 8.50423 3.92081 7.29167 5.41659 7.29167C6.08679 7.29167 6.7002 7.53551 7.17266 7.93816L11.9166 5.05841C11.8892 4.90392 11.8749 4.74513 11.8749 4.58333ZM5.41659 8.54167C4.61117 8.54167 3.95825 9.19458 3.95825 10C3.95825 10.8054 4.61117 11.4583 5.41659 11.4583C5.87365 11.4583 6.2813 11.2488 6.54969 10.9182C6.75334 10.6673 6.87492 10.3487 6.87492 10C6.87492 9.66529 6.76292 9.35851 6.57401 9.11264C6.30637 8.76429 5.88761 8.54167 5.41659 8.54167ZM14.5833 13.9583C13.9974 13.9583 13.491 14.3038 13.259 14.8048C13.1731 14.9901 13.1249 15.1969 13.1249 15.4167C13.1249 16.2221 13.7778 16.875 14.5833 16.875C15.3887 16.875 16.0416 16.2221 16.0416 15.4167C16.0416 14.6113 15.3887 13.9583 14.5833 13.9583Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6868_95339">
          <rect width="20" height="20" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconEditText = ({ color = "currentColor" }: { color: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6868_95265)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9022 2.04741C13.1479 1.81345 13.5353 1.81818 13.7752 2.05806L16.6919 4.97473C16.9359 5.2188 16.9359 5.61453 16.6919 5.85861L7.94186 14.6086C7.82465 14.7258 7.66568 14.7917 7.49992 14.7917H4.58325C4.23807 14.7917 3.95825 14.5118 3.95825 14.1667V10.8333C3.95825 10.6623 4.02836 10.4987 4.15222 10.3807L12.9022 2.04741ZM5.20825 11.1012V13.5417H7.24104L15.366 5.41667L13.3226 3.37324L5.20825 11.1012ZM2.70825 17.5C2.70825 17.1548 2.98807 16.875 3.33325 16.875H17.4999C17.8451 16.875 18.1249 17.1548 18.1249 17.5C18.1249 17.8452 17.8451 18.125 17.4999 18.125H3.33325C2.98807 18.125 2.70825 17.8452 2.70825 17.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6868_95265">
          <rect width="20" height="20" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
